export default __webpack_public_path__ + "static/media/roadmap_3.42555570.png";